import { ComponentProps } from 'react';
import ColorPicker from 'antd/es/color-picker';
import clsx from 'clsx';

interface OpColorPickerProps extends ComponentProps<typeof ColorPicker> {
  testId?: string;
}

/**
 * OpColorPicker is a wrapper around Ant Design's ColorPicker component.
 * It provides a color selection interface with various formats and presets.
 * 
 * Use this component when users need to select colors for theming, styling,
 * or customization features. Supports multiple color formats (hex, rgb, hsl).
 * 
 * @example
 * <OpColorPicker value={color} onChange={setColor} />
 * <OpColorPicker showText format="hex" />
 * 
 */
export const OpColorPicker = ({
  className,
  testId = 'op-color-picker',
  ...colorPickerProps
}: OpColorPickerProps) => {
  return (
    <ColorPicker
      className={clsx('op-color-picker', className)}
      data-testid={testId}
      {...colorPickerProps}
    />
  );
};
